import { Navigate } from "react-router-dom";

import { isSuperAdminSignedIn } from "./session";

/**
 * Gate for every /super-admin/* page. Independent of RoleRoute and AuthContext:
 * a signed-in portal user is still sent to the super admin sign-in screen.
 *
 * This is a routing guard, not the security boundary — it only checks that a
 * token exists, not that it's still valid. The API verifies the token on every
 * call and superAdminApi bounces back here on a 401.
 */
export default function SuperAdminRoute({ children }: { children: React.ReactNode }) {
  if (!isSuperAdminSignedIn()) return <Navigate to="/super-admin/sign-in" replace />;
  return <>{children}</>;
}
